var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import BCard from "bootstrap-vue/es/components/card/card";
import ResponsiveImage from "../ResponsiveImage.vue";
import Carousel from 'bootstrap-vue/es/components/carousel/carousel';
import CarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide';
import { parseImageCropDataSet } from "../../Helpers/Image.ts";
import YouTube from "../YouTube.vue";
import Background from '../Background.vue';
var youtubeQueryRegex = /[\?&]v=([^&]+)/i;
var Teaser = /** @class */ (function (_super) {
    __extends(Teaser, _super);
    function Teaser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Teaser.prototype, "imagesArray", {
        get: function () {
            if (!this.images)
                return [];
            if (this.images instanceof Array)
                return this.images.map(function (p) { return parseImageCropDataSet(p); });
            return [parseImageCropDataSet(this.images)];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Teaser.prototype, "youTubeId", {
        get: function () {
            if (!this.youTubeLink)
                return undefined;
            var match = youtubeQueryRegex.exec(this.youTubeLink);
            return (match && match[1])
                || this.youTubeLink.split('/').filter(function (p) { return p; }).slice(-1)[0]
                || undefined;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "subtitle", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], Teaser.prototype, "content", void 0);
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "downloadLink", void 0);
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "contentLink", void 0);
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "externalLink", void 0);
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "externalLinkText", void 0);
    __decorate([
        Prop({ type: [Array, String, Object], default: function () { return []; } })
    ], Teaser.prototype, "images", void 0);
    __decorate([
        Prop({ type: String })
    ], Teaser.prototype, "youTubeLink", void 0);
    __decorate([
        Prop({ type: Object })
    ], Teaser.prototype, "background", void 0);
    Teaser = __decorate([
        Component({
            name: "Teaser",
            components: {
                "b-card": BCard,
                ResponsiveImage: ResponsiveImage,
                "b-carousel": Carousel,
                "b-carousel-slide": CarouselSlide,
                YouTube: YouTube,
                Background: Background
            }
        })
    ], Teaser);
    return Teaser;
}(Vue));
export default Teaser;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Content/Teaser.vue
// module id = 174
// module chunks = 7 8 9